module.exports = __webpack_public_path__ + "img/favicon.5b8831dd.svg";